import { createSlice } from "@reduxjs/toolkit";
import { PartnerTransactionState } from "./types";
import { fetchPartnerTransaction } from "./partner-transaction-thunk";
import { ErrorType } from "@/shared/types";

const initialState: PartnerTransactionState = {
    transaction: null,
    error: null,
    isLoading: false
}

const partnerTransactionSlice = createSlice({
    name: 'partnerTransaction',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
        .addCase(fetchPartnerTransaction.pending, (state) => {
            state.isLoading = true
            state.error = null
        })
        .addCase(fetchPartnerTransaction.fulfilled, (state, action) => {
            state.isLoading = false
            state.error = null
            state.transaction = action.payload
        })
        .addCase(fetchPartnerTransaction.rejected, (state, action) => {
            state.error = action.payload as ErrorType ?? null
            state.isLoading = false
            state.transaction = null
        })
    },
})

export default partnerTransactionSlice.reducer